<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <v-row class="justify-content-center">
        <v-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">404</h1>
            <h4 class="pt-3">Oops! You're lost.</h4>
            <p class="text-muted">The page you are looking for was not found.</p>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404',
  metaInfo() {
    return {  
      title: `404 - ${this.$t("app_name")}`,
      script: [{
        type: 'application/ld+json',
        json: {
          "@context" : "https://schema.org",
          "@type" : "WebSite",
          "name" : `404 - ${this.$t("app_name")}`,
          "url" : window.location.href
        }
      }]
    }
  },
}
</script>
